export const COMMON_LOGGEDOUT = 'md/redux/commonTypes/COMMON_LOGGEDOUT'
export const COMMON_LOGGEDIN = 'md/redux/commonTypes/COMMON_LOGGEDIN'